var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayeredPeaksHaikei(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 450",
    width: 900,
    height: 450,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 260L129 254L257 297L386 278L514 260L643 268L771 262L900 259L900 451L771 451L643 451L514 451L386 451L257 451L129 451L0 451Z",
    fill: "#ffd23f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 274L129 312L257 303L386 292L514 318L643 317L771 313L900 319L900 451L771 451L643 451L514 451L386 451L257 451L129 451L0 451Z",
    fill: "#fdc839"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 303L129 325L257 319L386 332L514 310L643 316L771 318L900 336L900 451L771 451L643 451L514 451L386 451L257 451L129 451L0 451Z",
    fill: "#fcbd35"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 321L129 354L257 347L386 358L514 352L643 327L771 353L900 347L900 451L771 451L643 451L514 451L386 451L257 451L129 451L0 451Z",
    fill: "#f9b331"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 352L129 373L257 368L386 368L514 375L643 373L771 347L900 374L900 451L771 451L643 451L514 451L386 451L257 451L129 451L0 451Z",
    fill: "#f7a92e"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 397L129 392L257 395L386 382L514 386L643 390L771 395L900 390L900 451L771 451L643 451L514 451L386 451L257 451L129 451L0 451Z",
    fill: "#f49f2b"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 394L129 412L257 400L386 410L514 413L643 401L771 397L900 414L900 451L771 451L643 451L514 451L386 451L257 451L129 451L0 451Z",
    fill: "#f1952a"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 419L129 431L257 423L386 414L514 425L643 414L771 419L900 431L900 451L771 451L643 451L514 451L386 451L257 451L129 451L0 451Z",
    fill: "#ed8b29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayeredPeaksHaikei);
export default __webpack_public_path__ + "static/media/layered-peaks-haikei.c6e74abbcdc9ba53550462b3ecc248a0.svg";
export { ForwardRef as ReactComponent };